/** Levée quand une séquence est interrompue (combat fermé, nouvelle séquence). */
export class SequenceCancelled extends Error {
  constructor() {
    super('Séquence interrompue');
  }
}

/** Facteur de durée en mode accéléré (clic ou Espace pendant une séquence). */
const FAST_FACTOR = 0.2;

/** Rythme les animations : attentes accélérables et annulables. */
export class Pacer {
  private factor = 1;
  private generation = 0;

  get isFast(): boolean {
    return this.factor < 1;
  }

  /** Accélère la séquence en cours (jusqu'au prochain `normal()`). */
  hurry(): void {
    this.factor = FAST_FACTOR;
  }

  normal(): void {
    this.factor = 1;
  }

  /** Interrompt toutes les attentes en cours : elles lèvent `SequenceCancelled`. */
  cancel(): void {
    this.generation++;
    this.factor = 1;
  }

  async wait(ms: number): Promise<void> {
    await this.hold(ms * this.factor);
  }

  /** Attente que le mode accéléré ne raccourcit pas (une {pause} dans le texte). */
  async hold(ms: number): Promise<void> {
    const generation = this.generation;
    await new Promise((resolve) => setTimeout(resolve, ms));
    if (generation !== this.generation) throw new SequenceCancelled();
  }
}
